import { Component, OnInit, Input, ViewChild, ElementRef, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/core/services/user.service';
import { Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { CONST_AWS_API, API, COUNTRIES_LIST } from 'src/app/core/constants';
import { API as AWS_API } from 'aws-amplify';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppPaymentTVService } from 'src/app/core/services/app-payment-tv.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ValidationService } from 'src/app/core/services/validation.service';
import { SearchCountryField, CountryISO } from 'ngx-intl-tel-input-gg';
import { PaymentService } from 'src/app/core/services/payment.service';
import { MatDialog } from '@angular/material/dialog';
import { SignoutConfirmationDialogComponent } from '../../components/signout-confirmation-dialog/signout-confirmation-dialog.component';
import { StorageService } from './../../../core/services/storage.service';
import { CarouselConfig } from 'ngx-bootstrap/carousel';
import { UserAccountDialog } from '../../components/event-navigation/pages/event-tickets/event-tickets.component';
declare var Stripe: any;
declare let window: any;
var stripe;
var elements;
declare var fbq: any;
declare let $: any;
@Component({
  selector: 'app-merchandise',
  templateUrl: './merchandise.component.html',
  providers: [
    { provide: CarouselConfig, useValue: { noPause: true } }
  ],
  styleUrls: ['./merchandise.component.scss']
})
export class MerchandiseComponent implements OnInit {
  @Input() productsList;
  showActiveStreamBlockSubject: Subscription;
  activeBlock: String = '';
  userInfo: any = {};
  userInfoSubscription: Subscription;
  billingForm: FormGroup;
  address: string;
  countriesList = COUNTRIES_LIST;
  shippingCountriesList = COUNTRIES_LIST;
  billingCountry: any = {};
  shippingCountry: any = {};
  options: {};
  countryChanged: boolean = true;
  shippingForm: FormGroup;
  showCCForm = false;
  pastedText: any;
  selectedCountry: any = "US";
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  separateDialCode = true;
  timeInterval: any;
  card: any;
  cardError: string;
  validStripeForm = false;
  @ViewChild('cardInfo', { static: false }) cardInfo: ElementRef;
  taxPercentage = 0;
  invoice_id: any;
  streamInfo: any = {};
  currentLocation: any;
  settingsJSON: any;
  email: any;
  fromMobile: boolean = false;
  deviceData: any;
  streamId: any;
  streamUrl: any;
  ticket_key: any;
  rates: any;
  getCurrency: any;
  curExchangeRate: any;
  @Output() getPaymentData = new EventEmitter<any>();
  myInterval = 5000;
  currencyInfoSubscription: Subscription;
  ratesInfoSubscr: Subscription;
  activeProductsSubscr: Subscription;
  curExRate: any;
  slugInfoSubscr: Subscription;
  slugInfo: any;
  shippingList: any = [];
  selectedCard: any = {};
  selectedCardInfoSubscr: Subscription;
  showBillingForm: boolean = false;
  addressList: any = [];
  addressListInfoSubscr: Subscription;
  savedCardsListSubscr: Subscription;
  savedCardsList: any = [];
  newShippingForm: boolean = false;
  addNewCard: boolean = false;
  selectedShippingAddress: any = {};
  selectedBillingAddress: any = {};
  assets_url = environment.assets_url;
  currentTheme : any;
  clientDetails : any;
  transactionInfoSubscr:Subscription;
  transactionInfo: any;
  formStatusSubject: Subscription;
  organizationId: any;
  performerInfoSubscription!: Subscription;
  selectedTransaction: any;
  billingAddress: any;
  amt_without_pf: any;
  @Input() currentBlock;
  cryptoToken: any;
  cryptoSymbol: any;
  USD_Rates: any;
  currency_for_totAmt: any;
  amt_without_pf1: any;
  crypto_amount: number;
  sliced_crypto_amount: number;
  totalAmount:any;
  creatorCurrency:any;

  constructor(
    private userService: UserService,
    private commonSubscribeService: CommanSubscribeService,
    private ngxLoader: NgxUiLoaderService,
    public router: Router,
    public route: ActivatedRoute,
    private appPaymentService: AppPaymentTVService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private paymentService: PaymentService,
    public dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private storageService: StorageService
  ) { }

  ngOnInit() {
    this.deviceData = this.commonSubscribeService.getMobileOperatingSystem();
    this.creatorCurrency = this.getParam("creator_currency");
    this.organizationId = this.commonSubscribeService.perfomerInfoData?.data?.Data?.[0]?.organization_id;
    this.performerInfoSubscription = this.commonSubscribeService.getPerfomerInfo().subscribe(response => {
      this.organizationId = response?.data?.Data?.[0]?.organization_id;
    });
    this.getCurrencyRates();
    
    this.commonSubscribeService.getActiveProductsList().subscribe(response=>{
      this.productsList=response;
    })
    // this.currentBlock = "Merchandise";
    this.activeBlock = this.currentBlock ? this.currentBlock : 'Merchandise';
    this.clientDetails = environment.clientDetails;
    this.currentTheme = this.commonSubscribeService;
    this.savedCardsListSubscr = this.commonSubscribeService.getSavedCards().subscribe(response => {
      this.savedCardsList = response;
      if (this.savedCardsList.length == 0 && (this.addressList.length > 0 || this.addressList.length == 0) && this.addressList.billingAddress.length == 0) {
        this.showBillingForm = true;
      }
      if (this.savedCardsList.length == 0) {
        this.addNewCard = true;
      }
    })
    if (this.savedCardsList.length == 0) {
      this.addNewCard = true;
    }

    

    this.selectedCardInfoSubscr = this.commonSubscribeService.getSelectedCardInfo().subscribe(response => {
      this.selectedCard = response;
    });

    this.formStatusSubject = this.commonSubscribeService.getFormStatus().subscribe(response => {
      if(response){
        this.closeForm();
      }
    })
    this.clientDetails = environment.clientDetails;
    this.cryptoToken = this.clientDetails.crypto_token;
    this.cryptoSymbol = this.clientDetails.crypto_symbol;
    this.commonSubscribeService.getCurrencyRates("USD",result=>{
      this.USD_Rates = result;
    });
    this.totalAmount = this.commonSubscribeService.getTotalAmount().subscribe(response => {
      this.currency_for_totAmt = response.currency;
      this.amt_without_pf1 = response.amt_without_pf;
      this.crypto_amount = this.currency_for_totAmt ? this.commonSubscribeService.convertToCryptoAmount( this.finalAmount,this.USD_Rates[this.currency_for_totAmt]):0;
      this.sliced_crypto_amount = Math.trunc(this.crypto_amount * Math.pow(10, 3))/Math.pow(10, 3);
    })


    this.addressListInfoSubscr = this.commonSubscribeService.getAddressList().subscribe(response => {
      this.addressList = response;
      if (this.addressList.shippingAddress.length > 0) {
        let shippingAdd = this.addressList.shippingAddress.filter(a => a.shippingAddress);
        this.newShippingForm = shippingAdd.length > 0 ? true : false;
        let selectedAddress = this.addressList.shippingAddress.filter(a => a.defaultShippingAddress);
        this.selectedShippingAddress = selectedAddress.length > 0 ? selectedAddress[0] : {};
        // this.sameBillingAddress = false;
      } else if (this.addressList.shippingAddress.length == 0) {
        this.newShippingForm = true;
      }
      if (this.addressList.billingAddress.length > 0) {
        let billingAdd = this.addressList.billingAddress.filter(a => a.billingAddress);
        this.showBillingForm = billingAdd.length > 0 ? true : false;
        if (this.showBillingForm) {
          this.commonSubscribeService.formsValidationSubject.next(false);
        }
        let selectedAddress = this.addressList.billingAddress.filter(a => a.defaultBillingAddress);
        this.selectedBillingAddress = selectedAddress.length > 0 ? selectedAddress[0] : {};
        if(Object.keys(this.selectedBillingAddress).length > 0)
          this.commonSubscribeService.formsValidationSubject.next(true);
        if (this.showBillingForm) {
          this.buildBillingForm();
        }
      } else if (this.addressList.billingAddress.length == 0 && this.savedCardsList.length == 0) {
        this.showBillingForm = true;
      }
      if (this.showBillingForm && (this.addressList.billingAddress.length > 0 || this.addressList.billingAddress.length == 0)) {
        this.sameBillingAddress = false;
      }
    });

    this.transactionInfoSubscr = this.commonSubscribeService.getTransactionInfo().subscribe(response => {
      // transactionInfo is shared by every payment form; on the stream page this component stays
      // alive (CSS-hidden) while the Tips/PPV/Donations/Subscribe forms are used, so only act while
      // the merch panel is the one on screen. currentBlock is unset outside the stream page.
      const merchPanelActive = this.currentBlock === undefined || this.currentBlock === 'Merchandise' || this.currentBlock === 'MerchandiseProd';
      if (this.showPaymentForm && merchPanelActive) {
        this.transactionInfo = response;
        this.card = this.transactionInfo["card"];
        if (this.selectedCard && this.selectedCard.id) {
          this.makePayment('card');
        } else {
          this.makePayment();
        }
      }
    })

    this.getCurrency = this.storageService.getItem('currency');
    this.userInfo = this.commonSubscribeService.userInfo;
    this.userInfoSubscription = this.commonSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
      this.email = this.userInfo.email;
      if(this.userInfo.is_guest){
        this.showBillingForm = this.showShippingForm = this.newShippingForm = true;
      }
      if(this.userInfo && this.userInfo.id)
        this.getShoppingCartList();
    });
    if(this.userInfo && this.userInfo.id){
      this.email = this.userInfo.email;
    }
    this.ticket_key = this.getParam('ticket_key');


    this.activeProductsSubscr = this.commonSubscribeService.getActiveProductsList().subscribe(response => {
      if (response) {
        this.productsList = response;
        this.getStreamCampaigns('latest');
      }
    });

    //this.rates = this.commonSubscribeService.currencyRatesSubject;
    this.ratesInfoSubscr = this.commonSubscribeService.getCurencyRates().subscribe(response => {
      if (response) {
        this.rates = response;
        Object.keys(this.rates).forEach(rates => {
          if (this.getCurrency == rates) {
            this.curExchangeRate = this.rates[rates];
          }
        });
      }
    });

    this.currencyInfoSubscription = this.commonSubscribeService.getCurrencyInfo().subscribe(response => {
      if (response) {
        if (this.showAddressForms || this.showPaymentForm || this.paymentSuccess) {
          this.activeBlock = "Merchandise";
        }
        this.checkoutTimer = 0;
        this.showAddressForms = false;
        this.showPaymentForm = false;
        this.paymentSuccess = false;
        this.getCurrency = this.storageService.getItem('currency');
        this.getStreamCampaigns('cur');
        Object.keys(this.rates).forEach(rates => {
          if (this.getCurrency == rates) {
            this.curExchangeRate = this.rates[rates];
            this.getCurrency = this.storageService.getItem('currency');
            this.productsList.forEach(element => {
              element.stream_campaign_id = this.streamCampaignId;
              let data = {
                "streamData": this.streamInfo,
                "currentLocation": this.currentLocation,
                "currency": this.getCurrency
              }
              this.commonSubscribeService.getProductsPrice(this.productsList, element.id, data, result => {
                if (element.convertTo) {
                  element.price = result.price * this.curExchangeRate * 1.025;
                  element.currency_rate = this.curExchangeRate * 1.025;
                } else {
                  element.currency_rate = 1;
                }
                this.curExRate = element.currency_rate;
                element.price = Number(result.price.toFixed(2));
                element.currency_type = result.currency_type;
                element.amt_after_dis = element.price;
                if (element.discount_percentage) {
                  let val = element.price * (element.discount_percentage / 100);
                  val = Number(val.toFixed(2));
                  element.amt_after_dis = Number((element.price - val).toFixed(2));
                }
              })
              if (this.selectedProductInfo && this.selectedProductInfo.id) {
                if (element.id == this.selectedProductInfo.id) {
                  this.selectedProductInfo.amt_after_dis = element.amt_after_dis;
                  this.selectedProductInfo.currency_type = element.currency_type;
                  this.selectedProductInfo.currency_rate = element.currency_rate;
                  this.curExRate = element.currency_rate;
                  this.selectedProductInfo.price = element.price;
                }
              }
            });
          }

        })
        let data = {
          stream_id: this.streamId,
          currency: this.getCurrency
        }
        let url = API.CART_CURRENCY + '?NOLOADER';
        this.appPaymentService.postRequest(url, data).subscribe(result => {
          if (result.status == 0 && result.message == 'Success') {
            this.cartProducts = result['products'];
            if (this.cartProducts.length > 0) {
              this.cartproductsData();
            }
          } else {
            this.toastr.error(result["message"]);
          }
        }, error => {
        });
      }
    });

    this.showActiveStreamBlockSubject = this.userService.getShowActiveStreamBlock().subscribe(response => {
      this.showOverlay = false;
      this.enableGoToCart = false;
      // this.checkoutTimer = 0;
      // this.showAddressForms = false;
      // this.showPaymentForm = false;
      // this.paymentSuccess = false;
      this.timer = 120;
      if (response == "MerchandiseProd" || (response == "Merchandise" && !this.checkoutTimer) || (this.selectedProductInfo && Object.keys(this.selectedProductInfo).length > 0)) {
        setTimeout(() => {
          this.loadCarousel();
        }, 1000);
        this.activeBlock = response;
        this.checkoutTimer = 0;
        this.showAddressForms = false;
        this.showPaymentForm = false;
        this.paymentSuccess = false;
        if (this.streamCampaigns.length == 0) {
          this.getStreamCampaigns('first');
        } else {
          this.getProductDetails();
        }
        if (response == "Merchandise" || response == "MerchandiseProd")
          this.getShoppingCartList();
      }
    });

    this.slugInfo = this.commonSubscribeService.slugInfo;
    this.slugInfoSubscr = this.commonSubscribeService.getSlugData().subscribe(response => {
      this.slugInfo = response;
      this.streamInfo = this.slugInfo.stream_info ? this.slugInfo.stream_info : this.slugInfo;
      this.settingsJSON = this.streamInfo.settings_json ? JSON.parse(this.streamInfo.settings_json) : {};
      let myList = [];
      this.countriesList.forEach(c => {
        if (this.settingsJSON && this.settingsJSON.country_wise_shipping) {
          this.settingsJSON.country_wise_shipping.forEach(e => {
            if (e.country_name == c.alpha2code) {
              myList.push(c);
            }
          })
        }
      });
      this.shippingList = this.shippingCountriesList = myList;
    });

    if (this.router.url.includes('/product-payment/')) {
      this.fromMobile = true;
      this.getUserInfo(() => {
        this.getShoppingCartList();
        this.getLiveEventById();
        // this.proceedToCheckout();
      });
    } else {
      this.fromMobile = false;
    }
    this.streamId = this.route.snapshot.queryParams.stage ? Number(this.route.snapshot.queryParams.stage) : Number(this.getParam("stream_id"));
  }

  calFee(response) {
    this.selectedTransaction = response.selectedTransaction;
    if (this.currentBlock == "Merchandise") {
      this.selectedTransaction = response.selectedTransaction;
      this.amt_without_pf = this.productsTotal + this.taxAmount + this.shippingCost;
      if (this.selectedTransaction == "wallet" || this.selectedTransaction == "crypto") {
        this.processingFee = 0;
        this.finalAmount = this.amt_without_pf;
      } else if (this.selectedTransaction && this.selectedTransaction != "wallet") {
        this.processingFee = (this.amt_without_pf * (environment.processing_fee / 100)) + environment.fee_percentage;
        this.processingFee = Number(this.processingFee.toFixed(2));
        this.finalAmount = this.amt_without_pf + this.processingFee;
      }
      let data = {
        "total_amount": this.finalAmount,
        "currency": this.productCurrency,
        "processing_fee": this.processingFee ? this.processingFee : undefined,
        "amt_without_pf": this.amt_without_pf
      }
      this.commonSubscribeService.totalAmountSubject.next(data);
    }
  }

  newCard() {
    this.addNewCard = true;
    this.sameBillingAddress = false;
    this.selectedCard = {};
    if (this.addressList.billingAddress.length == 0)
      this.showBillingForm = true;
    this.buildBillingForm();
    this.commonSubscribeService.selectedCardSubject.next(false);
  }

  loadCarousel() {
    var t;

    var start = $('#myCarousel').find('.active').attr('data-interval');
    t = setTimeout("$('#myCarousel').carousel({interval: 5000});");
    console.log(start, t, "start")
    $('#myCarousel').on('slid.bs.carousel', function () {
      $('#myCarousel').carousel({
        pause: true
      });
      clearTimeout(t);
      var i = $(this).find('.active').attr('data-interval');
      console.log(i);

      $('#myCarousel').carousel({
        pause: true
      });
      t = setTimeout("$('#myCarousel').carousel();", i - 1000);
    })
    $('.carousel-control-next').on('click', function () {
      clearTimeout(t);
      $('#myCarousel').carousel({
        pause: false
      });
    });

    $('.carousel-control-prev').on('click', function () {
      clearTimeout(t);
      $('#myCarousel').carousel({
        pause: false
      });
    });
  }

  getLiveEventById() {
    let ids;
    ids = {
      "stream_id": this.streamId,
      "userid": this.userInfo.id,
    }
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: ids
    }
    this.ngxLoader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_LIVE_EVENT_BY_ID, data).then(response => {
      this.ngxLoader.stop();
      if (response['data']['statusCode'] == "200") {
        this.streamInfo = response['data']['Data']['stream_info'];
        this.commonSubscribeService.sendSlugData(this.streamInfo);
        this.getCurrencyRates();
        this.settingsJSON = this.streamInfo.settings_json ? JSON.parse(this.streamInfo.settings_json) : {};
        if (this.streamInfo.stream_status == 'pending' || this.streamInfo.stream_status == 'progress') {
          this.streamUrl = environment.CONSUMER_PORTAL + 'event/stream/' + this.ticket_key + '?stage=' + this.streamId;
        } else {
          this.streamUrl = environment.CONSUMER_PORTAL + 'event/watch/' + this.ticket_key + '?stage=' + this.streamId;
        }
        if (this.router.url.includes('/product-payment/')) {
          this.proceedToCheckout();
        }
      }
    });
  }

  getCurrencyRates() {
    let creator_currency = this.creatorCurrency? this.creatorCurrency : this.streamInfo.currency_type; 
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {}
    }
    let url = CONST_AWS_API.GET_EXCHANGE_RATES + '/' + creator_currency;
    this.ngxLoader.start();
    AWS_API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.data.statusCode === '200') {
        this.ngxLoader.stop();
        this.rates = response['data']['Data']['rates'];
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });
  }

  getUserInfo(callback) {
    let id = this.getParam('user_id')
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        // "Authorization": `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {
        "user_id": id,
        "organization_id": this.organizationId
      }
    }
    // this.loader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_USER_BY_ID, data).then(response => {
      // this.loader.stop();
      if (response.data.user) {
        let token = this.getParam('token');
        if (token) {
          response.data.user.access_token = token
        } else {
          response.data.user.access_token = response.data.user.session_token;
        }
        this.userInfo = this.commonSubscribeService.userInfo = response.data.user;
        this.commonSubscribeService.sendUserInfo(this.userInfo);
      }
      callback();
    }).catch(error => {
      // this.loader.stop();
    });
  }

  getParam(param) {
    try {
      let url = decodeURIComponent(location.href).split("?");
      let queryParams = url[1].split("&");
      let params = {};
      if (queryParams && queryParams.length > 0) {
        queryParams.forEach(p => {
          let p1 = p.split("=");
          params[p1[0]] = p1[1];
        });
      }
      return params[param];
    } catch (e) {
      console.log(e);
      return this.route.snapshot.queryParamMap.get(param);
    }
  }

  streamCampaigns: any = [];
  selectedProductInfo: any;
  displayProducts: any = [];
  streamCampaignId: any;
  getStreamCampaigns(from?) {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        "id": this.productsList.length > 0 ? this.productsList[0].stream_campaign_id : this.streamCampaignId
      }
    }
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_STREAM_CAMPAIGNS, data).then(response => {
      if (response.data.statusCode === '200') {
        if (response['data']['Data'].length > 0) {
          this.streamCampaignId = response['data']['Data'][0]['id'];
          this.streamCampaigns = response['data']['Data'][0]['products'];
          // this.displayProducts = this.streamCampaigns;
          if (this.productsList.length > 0 && this.streamCampaigns.length > 0 && from != 'cur') {
            this.getProductDetails(from);
          }
        }
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });
  }

  timerVal: any = 0;
  displayTimer: any = 0;
  description: any;
  getProductDetails(from?) {
    // this.productsList.forEach(product=>{
    //   if(product.isProductAdded){
    //     this.selectedProductInfo = product;
    //     if (this.selectedProductInfo.disTimer > 0) {
    //       this.timerVal = this.selectedProductInfo.disTimer;
    //       if (this.selectedProductInfo.price != this.selectedProductInfo.amt_after_dis)
    //         this.startTimer();
    //     }
    //   }
    // })
    if (this.productsList.length > 0) {
      let selProduct = false;
      this.streamCampaigns.forEach(strCam => {
        this.productsList.forEach(element => {
          if (element.id == strCam.id) {
            strCam.amt_after_dis = element.amt_after_dis;
            strCam.disTimer = element.disTimer;
            strCam.currency_type = element.currency_type;
            strCam.discount_percentage = element.discount_percentage
            strCam.prod_imgs = [];
            if (strCam.media_url && strCam.media_url.includes(',')) {
              let urls = strCam.media_url.split(',');
              strCam.product_img = urls[0];
              if (urls.length > 1) {
                urls.forEach(element => {
                  if (element != strCam.product_img) {
                    strCam.prod_imgs.push(element);
                  }
                });
              }
            } else {
              strCam.product_img = strCam.media_url ? strCam.media_url : this.assets_url + 'merch-default-image.png';
            }
          }
          strCam.currency_rate = element.currency_rate;
          if (element.id == strCam.id && element.isProductAdded && !selProduct) {
            this.selectedProductInfo = strCam;
            selProduct = true;
            if (this.selectedProductInfo.disTimer > 0) {
              this.timerVal = this.selectedProductInfo.disTimer;
              if (this.selectedProductInfo.price != this.selectedProductInfo.amt_after_dis)
                this.startTimer();
            }
          }
        });
      });
      if (this.selectedProductInfo && !from) {
        this.selectedProductInfo.editProduct = false;
        this.selectedProductInfo['selectedQuantity'] = 1;
        this.selectedProductInfo.formatted_attributes = [];
        if (this.selectedProductInfo.long_description && this.selectedProductInfo.long_description.length > 0)
          this.description = this.selectedProductInfo.long_description.length > 100 ? this.selectedProductInfo.long_description.slice(0, 100) + '...' : '';
        this.selectedProductInfo.showDescription = false;
      }
      if (this.selectedProductInfo && !this.selectedProductInfo['selectedQuantity']) {
        this.selectedProductInfo['selectedQuantity'] = 1;
      }
      if (this.selectedProductInfo && this.selectedProductInfo.attributes && this.selectedProductInfo.attributes.length > 0) {
        const grouped = this.selectedProductInfo.attributes.reduce((groups, attribute) => {
          const pos = attribute.name;
          groups[pos] = groups[pos] || [];
          groups[pos].push(attribute);
          return groups;
        }, {});
        this.selectedProductInfo.formatted_attributes = Object.keys(grouped).map(key => ({ attribute_name: key, attributesList: grouped[key] }));
      }
      // this.displayProducts = this.productsList.filter(a => !a.isProductAdded);
      if (from == 'latest') {
        this.getShoppingCartList(from);
      }
    }
  }

  continueSession: boolean = false;
  startTimer() {
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
    this.timeInterval = setInterval(() => {
      if (this.timerVal <= 0) {
        this.checkoutTimer = 0;
        if (!this.checkoutTimer && Object.keys(this.selectedProductInfo).length > 0) {
          this.selectedProductInfo.discount_percentage = 0;
          this.selectedProductInfo.amt_after_dis = this.selectedProductInfo.price ? this.selectedProductInfo.price : this.selectedProductInfo.original_price;
          clearInterval(this.timeInterval);
        } else {
          clearInterval(this.timeInterval);
          this.toastr.info('Session expired. Payment not completed in time. Please initiate payment again.');
          this.showAddressForms = false;
          this.showPaymentForm = false;
          this.activeBlock = "Merchandise";
          this.continueSession = true;
          this.commonSubscribeService.checkoutTimer.next(this.checkoutTimer);
          setTimeout(() => {
            this.loadCarousel();
          }, 1000);
          this.getShoppingCartList();
          return;
        }
        clearInterval(this.timeInterval);
      }
      if (this.timerVal > 0) {
        this.runTimer();
      }
    }, 1000);
  }

  runTimer() {
    var minutes = Math.floor(this.timerVal / 60);
    var secs = this.timerVal % 60;
    var hours = Math.floor(minutes / 60)
    minutes = minutes % 60;
    this.displayTimer = `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(secs)}`;
    this.timerVal = this.timerVal - 1;
  }

  pad(num) {
    return ("0" + num).slice(-2);
  }

  changeImg(img, index) {
    this.selectedProductInfo.prod_imgs[index] = this.selectedProductInfo.product_img;
    this.selectedProductInfo.product_img = img;
  }

  changeQuantity(product, event, type) {
    let selProd;
    if (this.productsList.length > 0) {
      this.productsList.forEach(e => {
        if (e.id == product.id) {
          product.inventory = e.inventory;
          selProd = e;
        }
      })
    }
    if (type && product.selectedQuantity) {
      this.selectedProductInfo.selectedQuantity = type == 'add' ? product.selectedQuantity = product.selectedQuantity + 1 : event = product.selectedQuantity == 1 ? 1 : product.selectedQuantity - 1;
    }
    if (selProd && selProd.limited_inventory && product.inventory < product.selectedQuantity && type == 'add') {
      this.selectedProductInfo.selectedQuantity = product.inventory;
      this.toastr.info("Only " + product.inventory + " products available");
      return;
    }
    if (product.selectedQuantity < 0 || product.selectedQuantity == 0)
      this.selectedProductInfo.selectedQuantity = 1;
  }

  changeAttributes(attr) {
    this.selectedProductInfo.formatted_attributes.forEach(a => {
      a.attributesList.forEach(attribute => {
        if (attr.attribute_id == attribute.attribute_id) {
          a.selectedAttr = attr.value;
        }
      });
    });
  }

  enableGoToCart: boolean = false;
  addToCart() {
    // this.selectedProductInfo.amt_after_dis = this.selectedProductInfo.discount_percentage ? this.selectedProductInfo.amt_after_dis : this.selectedProductInfo.price;
    let productInfo = {
      "brand_name": this.selectedProductInfo.brand_name,
      "name": this.selectedProductInfo.name,
      "long_description": this.selectedProductInfo.long_description,
      "product_img": this.selectedProductInfo.product_img,
      "prod_imgs": this.selectedProductInfo.prod_imgs,
      "currency_type": this.selectedProductInfo.currency_type,
      "discount_percentage": this.selectedProductInfo.discount_percentage,
      "discount_validity": this.selectedProductInfo.disTimer,
      "display_time": this.selectedProductInfo.display_time,
      "id": this.selectedProductInfo.id,
      "inventory": this.selectedProductInfo.inventory,
      "attributes": this.selectedProductInfo.formatted_attributes,
      "price": this.selectedProductInfo.amt_after_dis,
      "is_taxable": this.selectedProductInfo.is_taxable,
      "is_digital": this.selectedProductInfo.is_digital,
      "limited_inventory": this.selectedProductInfo.limited_inventory,
      "currency_rate": this.selectedProductInfo.currency_rate,
      "network_group_id": this.selectedProductInfo.network_group_id || null
    }
    let data = {
      "campaign_id": this.streamCampaignId ? this.streamCampaignId : this.productsList[0].stream_campaign_id,
      "variant_id": this.selectedProductInfo.product_variations_id,
      "quantity": this.selectedProductInfo.selectedQuantity,
      "details": productInfo,
      "discount_code": this.selectedProductInfo.discount_percentage ? "auto" : undefined,
      "stream_id": Number(this.route.snapshot.queryParams.stage),
      "currency_rate": this.selectedProductInfo.currency_rate
    };
    this.curExRate = this.selectedProductInfo.currency_rate;
    let url = API.ADD_TO_CART + '?NOLOADER';
    this.appPaymentService.postRequest(url, data).subscribe(result => {
      if (result.status == 0 && result.message == "Success") {
        // this.enableGoToCart = true;
        this.activeBlock = "Merchandise";
        setTimeout(() => {
          this.loadCarousel();
        }, 1000);
        this.getShoppingCartList();
        this.toastr.success("Product added to the cart");
      } else {
        this.toastr.info(result.message);
        if (result.message.includes('Discount expired')) {
          this.openDialog(this.selectedProductInfo);
        }
      }
    }, error => {
    });
  }

  itemIds = [];
  openDialog(productInfo, type?): void {
    let disVal = 'Do you want to procced with original amount for ' + productInfo.name
    const dialogRef = this.dialog.open(SignoutConfirmationDialogComponent, {
      width: '370px',
      panelClass: 'app-signout-confirmation',
      data: disVal,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {
        if (!type) {
          this.selectedProductInfo.discount_percentage = 0;
          this.addToCart();
        } else {
          let data = {
            ids: this.itemIds, stream_id: this.streamId
          }
          let url = API.CONFIRM_CHECKOUT + '?NOLOADER';
          this.appPaymentService.postRequest(url, data).subscribe(result => {
            if (result.status == 0 && result.message == "Success") {
              if (type == 'checkout') {
                this.paymentDetails();
              } else {
                this.proceedToCheckout();
              }
            } else {
              this.toastr.info(result.message);
            }
          }, error => {
          });
        }
      } else if (result == 'no') {
        if (type && type == 'checkout') {
          this.showAddressForms = false;
          this.showPaymentForm = false;
          this.activeBlock = "Merchandise";
          setTimeout(() => {
            this.loadCarousel();
          }, 1000);
          this.getShoppingCartList();
        }
      }
    });
  }

  goToCart() {
    this.activeBlock = "Merchandise";
    this.getShoppingCartList();
  }

  showDesc() {
    this.selectedProductInfo.showDescription = !this.selectedProductInfo.showDescription;
  }

  buyProduct(product) {
    this.userService.sendStatus(false);
    this.productsList.forEach(element => {
      if (element.id == product.id) {
        element.isProductAdded = true;
      } else {
        element.isProductAdded = false;
      }
    });
    this.userService.showActiveStreamBlock.next('MerchandiseProd');
  }

  cartProducts: any = [];
  productsTotal = 0;
  productCurrency = '';
  cart_id: any;
  discountAmount = 0;
  digitalProducts: any = [];
  showShippingForm: boolean = false;
  cartProductsAvailable: boolean = false;
  getShoppingCartList(from?) {
    this.displayProducts = this.productsList;
    let data = {
      "stream_id": this.streamId,
      "network_group_id": this.streamInfo?.network_group_id || this.commonSubscribeService?.activeGroupId || null
    };
    let url = API.SHOPPING_CART_LIST + '?NOLOADER';
    this.appPaymentService.postRequest(url, data).subscribe(result => {
      if (result.status == 0 && result.message == 'Success') {
        this.cartProducts = result['result'];
        this.cartproductsData(from);
      }
    }, error => {
    });
  }

  cartproductsData(from?) {
    if (this.productsList && this.productsList.length > 0 && this.cartProducts.length > 0) {
      this.productsList.forEach(e => {
        e.shoppingCart = false;
        this.cartProducts.forEach(p => {
          if (e.id == p.product_id) {
            e.shoppingCart = true;
            p.inventory = e.inventory;
          }
        })
      })
    }
    this.cartProductsAvailable = true;
    this.productsTotal = 0;
    this.discountAmount = 0;
    this.itemIds = [];
    // this.selectedProductInfo = {};
    let orgProdAmount = 0; let orgTotal = 0;
    // this.commonSubscribeService.cartProductsSubject.next(this.cartProducts);
    if (this.cartProducts.length > 0) {
      this.cartProducts.forEach(element => {
        if (element.product_data) {
          element.product_info = JSON.parse(element.product_data);
        }
        // if(!this.curExRate && element.product_info.currency_rate)
        this.curExRate = element.currency_rate;
        element.totalPrice = element.quantity * element.price;
        this.cart_id = element.cart_id;
        this.productCurrency = element.product_info.currency_type;
        this.productsTotal += element.totalPrice;
        this.productsTotal = Number(this.productsTotal.toFixed(2));
        orgProdAmount = element.quantity * element.original_price;
        orgTotal += orgProdAmount;
        orgTotal = Number(orgTotal.toFixed(2));
        // if (element.product_info.discount_percentage) {
        //   let val = (element.original_price * element.quantity) * (element.product_info.discount_percentage / 100);
        //   val = Number(val.toFixed(2));
        //   this.discountAmount += val;
        // }
      });
      let val = orgTotal - this.productsTotal;
      if (val)
        this.discountAmount = Number(val.toFixed(2));
      this.digitalProducts = this.cartProducts.filter(a => a.product_info.is_digital);
      this.showShippingForm = this.digitalProducts.length != this.cartProducts.length ? true : false;
      if (this.showShippingForm && ((this.addressList.shippingAddress && this.addressList.shippingAddress.length == 0) || this.userInfo.is_guest)) {
        this.newShippingForm = true;
      }
      if (this.router.url.includes('/product-payment/')) {
        if (this.settingsJSON && this.settingsJSON.country_wise_shipping && this.showShippingForm) {
          this.checkShippingPrice('default');
        }
      }
      this.cartProducts.forEach(element => {
        this.itemIds.push(element.id);
      });
      this.displayProducts = [];
      if (this.productsList && this.productsList.length > 0) {
        this.displayProducts = this.productsList.filter(a => !a.shoppingCart);
      }
      if (from == 'latest' && !this.router.url.includes('/product-payment/')) {
        setTimeout(() => {
          this.loadCarousel();
        }, 1000);
      }
    }
    this.commonSubscribeService.cartProductsSubject.next(this.cartProducts);
  }

  editProduct(product) {
    this.selectedProductInfo = {};
    if (this.productsList.length > 0) {
      this.productsList.forEach(e => {
        if (e.id == product.product_info.id) {
          this.selectedProductInfo.inventory = e.inventory;
        }
      })
    }
    this.userService.showActiveStreamBlock.next('MerchandiseProd');
    this.description = product.product_info.long_description.length > 100 ? product.product_info.long_description.slice(0, 100) + '...' : '';
    this.selectedProductInfo.amt_after_dis = product.price;
    this.selectedProductInfo.name = product.product_info.name;
    this.selectedProductInfo.brand_name = product.product_info.brand_name,
      this.selectedProductInfo.long_description = product.product_info.long_description;
    this.selectedProductInfo.product_img = product.product_info.product_img;
    this.selectedProductInfo.prod_imgs = product.product_info.prod_imgs;
    this.selectedProductInfo.formatted_attributes = product.product_info.attributes;
    this.selectedProductInfo.selectedQuantity = product.quantity;
    this.selectedProductInfo.currency_type = product.product_info.currency_type;
    if (this.productsList.length == 0)
      this.selectedProductInfo.inventory = product.product_info.inventory;
    this.selectedProductInfo.id = product.product_info.id;
    this.selectedProductInfo.editProduct = true;
    this.selectedProductInfo.campaign_id = product.campaign_id;
    this.selectedProductInfo.variant_id = product.variant_id;
    this.selectedProductInfo.discount_percentage = product.product_info.discount_percentage;
    this.selectedProductInfo.discount_validity = product.product_info.disTimer;
    this.selectedProductInfo.original_price = product.original_price;
    this.selectedProductInfo.is_taxable = product.product_info.is_taxable;
    this.selectedProductInfo.is_digital = product.product_info.is_digital;
    this.selectedProductInfo.item_id = product.id;
    this.selectedProductInfo.cart_id = product.cart_id;
    this.selectedProductInfo.limited_inventory = product.product_info.limited_inventory;
    if (this.selectedProductInfo.disTimer > 0) {
      this.timerVal = this.selectedProductInfo.disTimer;
      if (this.selectedProductInfo.original_price != this.selectedProductInfo.amt_after_dis) {
        this.startTimer();
      }
    }
  }

  deleteProduct(product) {
    let data = {
      "variant_id": product.variant_id,
      "cart_id": product.cart_id,
      "item_id": product.id
    };
    let url = API.DELETE_PRODUCT + '?NOLOADER';
    this.appPaymentService.postRequest(url, data).subscribe(result => {
      if (result.status == 1 && result.message == 'Success') {
        this.toastr.success('Product deleted successfully');
        this.getShoppingCartList();
      }
    }, error => {
    });
  }

  updateProduct(product) {
    let productInfo = {
      "name": this.selectedProductInfo.name,
      "long_description": this.selectedProductInfo.long_description,
      "product_img": this.selectedProductInfo.product_img,
      "prod_imgs": this.selectedProductInfo.prod_imgs,
      "currency_type": this.selectedProductInfo.currency_type,
      "discount_percentage": this.selectedProductInfo.discount_percentage,
      "discount_validity": this.selectedProductInfo.disTimer,
      "id": this.selectedProductInfo.id,
      "inventory": this.selectedProductInfo.inventory,
      "attributes": this.selectedProductInfo.formatted_attributes,
      "price": this.selectedProductInfo.amt_after_dis,
      "is_digital": this.selectedProductInfo.is_digital,
      "limited_inventory": this.selectedProductInfo.limited_inventory,
      "currency_rate": this.selectedProductInfo.currency_rate
    }
    let data = {
      "campaign_id": product.campaign_id,
      "variant_id": product.variant_id,
      "quantity": product.selectedQuantity,
      "details": productInfo,
      "discount_code": this.selectedProductInfo.discount_percentage ? "auto" : undefined,
      "cart_item_id": this.selectedProductInfo.item_id,
      "cart_id": this.selectedProductInfo.cart_id,
      "currency_rate": this.selectedProductInfo.currency_rate
    };
    this.curExRate = this.selectedProductInfo.currency_rate;
    let url = API.UPDATE_PRODUCT + '?NOLOADER';
    this.appPaymentService.postRequest(url, data).subscribe(result => {
      if (result.status == 0 && result.message == 'Success') {
        this.activeBlock = "Merchandise";
        this.selectedProductInfo.editProduct = false;
        setTimeout(() => {
          this.loadCarousel();
        }, 1000);
        this.getShoppingCartList();
        this.toastr.success('Product updated successfully');
      } else {
        this.toastr.error(result["message"]);
      }
    }, error => {
    });
  }

  showAddressForms: boolean = false;
  checkoutTimer = 0;
  checkout() {
    this.paymentResp = {};
    let checkoutUrl = API.INITIATE_CHECKOUT + '?NOLOADER';
    let params = { "stream_id": this.streamId }
    this.appPaymentService.postRequest(checkoutUrl, params).subscribe(result => {
      if (result['status'] == 0 && result.message == 'Success') {
        this.proceedToCheckout();
      } else {
        if (result["errors"])
          this.toastr.error(result["message"] + ", one or more products' inventory is changed. Please review the cart and update or delete the products.");
        else
          this.toastr.error(result['message']);
        let errors = result["errors"];
        if (errors && Object.keys(errors).length > 0) {
          this.cartProducts.forEach(e => {
            for (const [key, value] of Object.entries(errors)) {
              if (key == e.id) {
                e.invNotAvailable = true;
                e.inventory = value["inventory"];
                e.product_info.inventory = e.inventory;
              }
            }
          })
          const sorted = this.cartProducts.sort((a, b) => a.invNotAvailable ? -1 : 1);
          this.cartProducts = sorted;
        }
      }
    });
  }

  proceedToCheckout() {
    this.isPayment = false;
    this.addNewCard = false;
    this.commonSubscribeService.cartProductsSubject.next(this.cartProducts);
    this.commonSubscribeService.selectedCardSubject.next(false);
    if (!this.showShippingForm) {
      this.shippingCost = 0;
    }
    let myList = [];
    let countriesList = COUNTRIES_LIST;
    countriesList.forEach(c => {
      if (this.settingsJSON && this.settingsJSON.country_wise_shipping) {
        this.settingsJSON.country_wise_shipping.forEach(e => {
          if (e.country_name == c.alpha2code) {
            myList.push(c);
          }
        })
      }
    });
    this.shippingList = this.shippingCountriesList = myList;
    this.cartUrl = "";
    this.continueSession = false;
    this.timer = 120;
    this.checkoutTimer = this.timerVal = 300;
    this.startTimer();
    this.selectedProductInfo = {};
    let locInfo = this.commonSubscribeService.locationInfo;
    this.currentLocation = locInfo && Object.keys(locInfo).length > 0 ? locInfo : this.storageService.getItem('current_location');
    this.activeBlock = '';
    this.showAddressForms = true;
    this.buildBillingForm();
    // if (this.showShippingForm)
    this.buildShippingForm();
    this.commonSubscribeService.checkoutTimer.next(this.checkoutTimer);
  }

  buildBillingForm() {
    this.countriesList = COUNTRIES_LIST;
    this.billingForm = this.formBuilder.group({
      address1: ['', Validators.required],
      address2: [''],
      city: ['', Validators.required],
      state: ['', Validators.required],
      country: ['', [Validators.required, ValidationService.autoCompleteValueSelected(this.countriesList, 'name')]],
      zip: ['', Validators.required],
    });
    if (!this.showShippingForm && this.currentLocation) {
      this.countriesList.forEach(country => {
        if (country.alpha2code == this.currentLocation.country_code2) {
          // this.countryChanged = false
          this.selectedCountry = country.alpha2code;
          this.billingForm.patchValue({
            country: country
          });
        }
      })
    }
  }

  buildShippingForm() {
    this.shippingForm = this.formBuilder.group({
      address1: ['', Validators.required],
      address2: [''],
      city: ['', Validators.required],
      state: ['', Validators.required],
      country: ['', [Validators.required, ValidationService.autoCompleteValueSelected(this.shippingCountriesList, 'name')]],
      zip: ['', Validators.required],
      phone_number: ['', [Validators.required]]
    });
    if (!this.currentLocation || Object.keys(this.currentLocation).length == 0) {
      this.commonSubscribeService.getCurrentLocation((val: any, json: any) => {
        console.log(json);
        if (val == "fail") {
          this.currentLocation = {};
        } else {
          this.currentLocation = json;
          this.getShippingInfo();
        }
      });
    } else if (this.currentLocation) {
      this.getShippingInfo();
    }
  }

  getShippingInfo(){
    if (this.currentLocation) {
      this.shippingCountriesList.forEach(country => {
        if (country.alpha2code == this.currentLocation.country_code2) {
          this.countryChanged = false
          this.selectedCountry = country.alpha2code;
          this.billingForm.patchValue({
            country: country
          });
          this.shippingForm.patchValue({
            country: country
          });
          this.options = {
            types: [],
            componentRestrictions: { country: country.alpha2code }
          };
          this.checkState(country);
          setTimeout(() => { this.countryChanged = true });
          if (this.settingsJSON && this.settingsJSON.country_wise_shipping && this.showShippingForm) {
            this.checkShippingPrice('default');
          }
        }
      });
    }
  }

  billingFormLat: any;
  billingFormLong: any;
  shippingFormLong: any;
  shippingFormLat: any;
  getSelectedAddress(val, formType?) {
    var myAddress = {
      name: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      country: '',
      zip: '',
      copy: false
    };
    let street = val && val.formatted_address ? val.formatted_address.split(',') : val.split(',');
    this.address = street[0];
    if (val && val.formatted_address)
      val = val.formatted_address
    else
      val = this.pastedText;
    myAddress.address1 = this.address;
    if (val) {
      this.commonSubscribeService.getAddress(val, (result) => {
        if (result) {
          let place = {
            address_components: result['results'][0]['address_components'],
            geometry: result['results'][0].geometry
          }
          if (place && place.geometry.location.lat && formType == 'billingForm') {
            this.billingFormLat = place.geometry.location.lat;
            this.billingFormLong = place.geometry.location.lng;
          } else if (place && place.geometry.location.lat && formType == 'shippingForm') {
            this.shippingFormLat = place.geometry.location.lat;
            this.shippingFormLong = place.geometry.location.lng;
          }
          if (place && place.address_components) {
            place.address_components.forEach(element => {
              if ((element.types[0] == "sublocality_level_1" || element.types[0] == "premise") && element.long_name)
                myAddress.address2 = element.long_name;

              if ((element.types[0] == "locality" || element.types[0] == "postal_town") && element.long_name)
                myAddress.city = element.long_name;
              if ((element.types[0] == "administrative_area_level_1" || element.types[0] == "administrative_area_level_2") && element.long_name)
                myAddress.state = element.long_name;
              if (element.types[0] == "country" && element.long_name)
                myAddress.country = element.long_name;
              if (element.types[0] == "postal_code" && element.long_name)
                myAddress.zip = element.long_name;
            });
          }
          let country = myAddress.country && val ? COUNTRIES_LIST.find(c => c.name === myAddress.country) : COUNTRIES_LIST.find(c => c.name === myAddress.country);
          if (country.alpha2code != this.currentLocation.country_code2 && formType == 'shippingForm') {
            this.toastr.error("Shipping is not available in your region");
            this.buildShippingForm();
            return;
          }
          if (formType == 'shippingForm') {
            this.getBillingAddress(myAddress, formType);
          } else {
            this.getBillingAddress(myAddress, formType, '', 'proceed')
          }
        }
      });
      // }).catch((error)=>{
      //   this.loader.stop();
      // });
    }
  }

  getBillingAddress(myAddress, formType, val?, type?) {
    let formVal = formType == 'billingForm' ? this.billingForm : this.shippingForm;
    let country = myAddress.country && val ? COUNTRIES_LIST.find(c => c.name === myAddress.country.name) : COUNTRIES_LIST.find(c => c.name === myAddress.country);
    if ((formType == 'billingForm' && this.sameBillingAddress) || formType == 'shippingForm' || type == 'proceed') {
      formVal.patchValue({
        address1: myAddress.address1 ? myAddress.address1 : this.address,
        address2: myAddress.address2,
        city: myAddress.city,
        state: myAddress.state,
        country: country ? country : {},
        zip: myAddress.zip
      });
      if (this.showShippingForm) {
        // setTimeout(() => {
        this.checkShippingAddress(this.shippingForm.value, val, type);
        this.checkShippingPrice();
        return;
        // }, 100);
      }
    }
    // if (this.showShippingForm)
    //   this.checkShippingPrice();
  }

  checkShippingAddress(myAddress?, val?, type?) {
    myAddress = this.shippingForm.value;
    if ((this.shippingForm.valid || (this.getShippingValue.address1 && this.getShippingValue.city && this.getShippingValue.state && this.getShippingValue.country && this.getShippingValue.zip)) && this.sameBillingAddress) {
      let country = myAddress.country && val ? COUNTRIES_LIST.find(c => c.name === myAddress.country.name) : COUNTRIES_LIST.find(c => c.name === myAddress.country.name);
      this.checkState(country);
      this.billingForm.patchValue({
        address1: myAddress.address1 ? myAddress.address1 : this.address,
        address2: myAddress.address2,
        city: myAddress.city,
        state: myAddress.state,
        country: country ? country : {},
        zip: myAddress.zip
      });
    }
  }

  sameBillingAddress = true;
  populateBillingAddress(event) {
    if (event && event.checked) {
      this.sameBillingAddress = true;
      this.getBillingAddress(this.shippingForm.value, 'billingForm', true);
    } else {
      this.sameBillingAddress = false;
      this.buildBillingForm();
    }
  }

  setCountry(e: any) {
    if (e.target.value) {
      this.countryChanged = false;
      let selectCountryInfo = this.countriesList.find(c => c.name.toLowerCase() === e.target.value.toLowerCase());
      this.billingForm.get('country').setValue(selectCountryInfo);
      if (selectCountryInfo && selectCountryInfo.alpha2code) {
        this.countryChanged = false;
        this.options = {
          types: [],
          componentRestrictions: { country: selectCountryInfo.alpha2code }
        };
        setTimeout(() => { this.countryChanged = true });
      }
    }
  }
  onPasteLocation(event: ClipboardEvent,formType) {
    let clipboardData = event.clipboardData || window.clipboardData;
    this.pastedText = clipboardData.getData('text');
    this.getSelectedAddress(this.pastedText,formType);
  }

  get getBillingValue() {
    return this.billingForm.getRawValue();
  }

  get getShippingValue() {
    return this.shippingForm.getRawValue();
  }

  shippingCost = 0;
  selectCountry(country, formType) {
    this.countryChanged = false;
    if (formType == "shippingForm") {
      this.shippingCountry = country.value;
    } else if (formType == "billingForm" || this.sameBillingAddress) {
      this.billingCountry = country.value;
    }
    if (formType == 'shippingForm')
      this.selectedCountry = country.value.alpha2code;
    this.options = {
      types: [],
      componentRestrictions: { country: country.value.alpha2code }
    };
    if (formType == 'billingForm') {
      this.billingForm.patchValue({
        address1: "",
        address2: "",
        city: "",
        state: "",
        // country: "",
        zip: ""
      });
    } else {
      this.shippingForm.patchValue({
        address1: "",
        address2: "",
        city: "",
        state: "",
        // country: "",
        zip: "",
        phone_number: ""
      });
    }
    this.checkState(country.value);
    setTimeout(() => { this.countryChanged = true });
    if (this.settingsJSON && this.settingsJSON.country_wise_shipping && this.showShippingForm && formType == 'shippingForm') {
      this.checkShippingPrice();
    }
  }

  checkShippingPrice(type?) {
    if (this.settingsJSON && this.settingsJSON.country_wise_shipping && this.settingsJSON.country_wise_shipping.length > 0) {
      let val = false;
      this.settingsJSON.country_wise_shipping.forEach(e => {
        if (e.country_name.includes(this.getShippingValue.country.alpha2code)) {
          this.shippingCost = Number(e.shipping_cost);
          if (this.curExchangeRate != 1 && !this.router.url.includes('/product-payment/')) {
            this.shippingCost = this.shippingCost * this.curExchangeRate * 1.025;
            // if(!this.router.url.includes('/product-payment/')){
            //   this.shippingCost = this.shippingCost*1.025;
            // }
          }
          if (this.router.url.includes("/product-payment/")) {
            Object.keys(this.rates).forEach(rates => {
              if (this.productCurrency == rates) {
                this.curExchangeRate = this.rates[rates];
              }
            })
            if (this.curExchangeRate != 1)
              this.shippingCost = this.shippingCost * this.curExchangeRate * 1.025;
          }
          val = true;
          this.shippingCost = Number(this.shippingCost);
        }
      })
      setTimeout(() => {
        if (!val) {
          this.shippingForm.patchValue({
            country: ""
          });
          if (!type) {
            this.toastr.info('Shipping is not possible');
          }
          return;
        }
      }, 10);
    }
  }

  displayCountryName(option) {
    return option ? option.name : undefined;
  }

  filterCountry(form) {
    this.shippingCountriesList = this.shippingList;
    if (this[form].country) {
      let countriesList = form == "getShippingValue" && this.shippingCountriesList.length > 0 ? JSON.parse(JSON.stringify(this.shippingCountriesList)) : JSON.parse(JSON.stringify(COUNTRIES_LIST));
      this.shippingForm.get('country').setValidators([Validators.required, ValidationService.autoCompleteValueSelected(countriesList, 'name')]);
      const filterValue = this[form].country.toLowerCase();
      if (form == "getShippingValue") {
        this.shippingCountriesList = countriesList.filter(option => option.name.toLowerCase().indexOf(filterValue) >= 0);
      } else {
        this.countriesList = countriesList.filter(option => option.name.toLowerCase().indexOf(filterValue) >= 0);
      }
    }
    // else {
    //   this.shippingCountriesList = this.countriesList = [];
    // }
  }

  checkState(country) {
    if (country && country.stateless == "yes") {
      this.billingForm.get("state").setValidators([]);
      this.billingForm.get("state").updateValueAndValidity();
      this.shippingForm.get("state").setValidators([]);
      this.shippingForm.get("state").updateValueAndValidity();
    }
  }

  get businessPhoneValue() {
    return this.shippingForm.controls['phone_number'];
  }

  showPaymentForm: boolean = false;
  codes: any = {};
  finalAmount: any;
  proceed() {
    if(this.billingForm.invalid){
      this.getBillingAddress(this.shippingForm.value, 'billingForm', true);
    }
    this.isPayment = false;
    // this.checkShippingPrice();
    this.getBillingValue.activeBlock = "Merchandise";
    this.commonSubscribeService.billingInfoSubject.next(this.getBillingValue);
    if (this.selectedCard && this.selectedCard.id) {
      let card = this.selectedCard.billing_address;
      this.selectedBillingAddress.line1 = card.line1;
      this.selectedBillingAddress.line2 = card.line2;
      this.selectedBillingAddress.city = card.city;
      this.selectedBillingAddress.country = card.country;
      this.selectedBillingAddress.state = card.state;
      this.selectedBillingAddress.zip = card.postal_code;
    }
    if ((this.billingForm.valid && (this.shippingForm.valid || !this.showShippingForm)) || ((((Object.keys(this.selectedShippingAddress).length > 0 || this.shippingForm.valid) || !this.showShippingForm) && (Object.keys(this.selectedBillingAddress).length > 0 || this.billingForm.valid)))) {
      this.commonSubscribeService.formsValidationSubject.next(true);
      let country;
      if (this.selectedCard && this.selectedCard.id) {
        this.countriesList.forEach(element => {
          if (element.alpha2code == this.selectedCard.billing_address.country) {
            country = element;
          }
        });
      }
      let zip = this.getBillingValue.zip ? this.getBillingValue.zip : this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : ""
      let cName = this.getBillingValue.country.name ? this.getBillingValue.country.name : this.selectedBillingAddress && this.selectedBillingAddress.country ? country ? country.name : this.selectedBillingAddress.country : ""
      this.commonSubscribeService.validateZip(zip, cName, (result) => {
        if (result.status) {
          this.processingFee = 0;
          this.codes = result;
          let country = COUNTRIES_LIST.filter(country => country.alpha2code == this.codes.country)
          this.codes.country = country[0].alpha3code;
          let zipCode = this.showShippingForm || (this.selectedShippingAddress && this.selectedShippingAddress.zip) ? this.getShippingValue.zip : this.selectedShippingAddress && this.selectedShippingAddress.zip ? this.selectedShippingAddress.zip : zip;
          this.getTaxPercentage(zipCode, () => {
            this.showPaymentForm = true;
            this.showAddressForms = false;
            this.showCCForm = true;
            this.finalAmount = this.productsTotal + this.taxAmount + this.shippingCost;
            this.amt_without_pf = this.finalAmount = Number(this.finalAmount.toFixed(2));
            this.processingFee = (this.finalAmount * (environment.processing_fee / 100)) + environment.fee_percentage;
            this.processingFee = Number(this.processingFee.toFixed(2));
            this.finalAmount = this.finalAmount + this.processingFee;
            this.finalAmount = Number(this.finalAmount.toFixed(2));
            let data={
              "total_amount": this.finalAmount,
              "currency": this.productCurrency,
              "processing_fee": this.processingFee ? this.processingFee : undefined,
              "amt_without_pf": this.amt_without_pf
            }
            this.commonSubscribeService.totalAmountSubject.next(data);
          });
        } else {
          this.toastr.error('Invalid zip code');
        }
        this.commonSubscribeService.scrollStatusSubject.next('scroll-bottom');
      });
      if (this.getShippingValue.address1 && this.showShippingForm) {
        this.commonSubscribeService.validateZip(this.getShippingValue.zip, this.getShippingValue.country.name, (result) => {
          if (result.status) {
            this.shippingCodes = result;
            let country = COUNTRIES_LIST.filter(country => country.alpha2code == this.shippingCodes.country);
            this.shippingCodes.country = country[0].alpha3code;
          }
          else {
            this.toastr.error('Invalid zip code');
          }
        });
      }
    } else if (this.shippingForm.invalid && this.showShippingForm && Object.keys(this.selectedShippingAddress).length == 0) {
      var merch = document.getElementById('merchandise');
      setTimeout(() => {
        merch.scrollLeft = 0;
      }, 10);
      this.toastr.error('Please fill shipping information');
      this.commonSubscribeService.scrollToError();
      this.commonSubscribeService.markFormGroupTouched(this.shippingForm);
      return;
    } else if (this.billingForm.invalid && Object.keys(this.selectedShippingAddress).length == 0) {
      this.toastr.error('Please fill billing information');
      this.commonSubscribeService.scrollToError();
      this.commonSubscribeService.markFormGroupTouched(this.billingForm);
      return;
    }
  }

  editAddress() {
    this.showPaymentForm = false;
    this.showAddressForms = true;
  }

  closeForm() {
    this.showPaymentForm = false;
    this.showAddressForms = false;
    this.activeBlock = 'Merchandise';
    this.checkoutTimer = 0;
    setTimeout(() => {
      this.loadCarousel();
    }, 1000);
    this.getShoppingCartList();
    this.commonSubscribeService.checkoutTimer.next(this.checkoutTimer);
    return;
  }

  taxAmount = 0;
  incl: any;
  processingFee = 0;
  getTaxPercentage(zip, callback) {
    let addOnAmount = 0;
    this.cartProducts.forEach(element => {
      if (element.product_info.is_taxable) {
        addOnAmount += element.totalPrice;
      }
    });
    if (addOnAmount) {
      if (this.showShippingForm) {
        addOnAmount = addOnAmount + this.shippingCost;
      }
      // this.processingFee = (addOnAmount * (2.9 / 100)) + 0.3;
      // this.processingFee = Number(this.processingFee.toFixed(2));
      // addOnAmount = addOnAmount + this.processingFee;
      addOnAmount = Number(addOnAmount.toFixed(2));
    }
    if (addOnAmount > 0) {
      let data: any = {
        access_token: this.userInfo.access_token,
        amount: 0,
        // liveAmount: liveAmount,
        stream_id: this.streamId,
        payment_type: 'order',
        currency: this.productCurrency,
        address: {
          street1: this.getBillingValue.address1,
          city: this.getBillingValue.city,
          state: this.getBillingValue.state,
          state_code: this.codes.state,
          zip: this.getBillingValue.zip,
          country: this.getBillingValue.country.name,
          country_code: this.codes.country
        },
        addOnAmount: addOnAmount
      };
      this.paymentService.calculateTax(data, (result) => {
        if (result.status == 0) {
          this.taxPercentage = result.data.taxPercentage;
          this.taxAmount = result.data.tax;
          this.taxAmount = Number(this.taxAmount.toFixed(2));
          this.finalAmount = result.data.finalAmount;
          this.finalAmount = this.productsTotal + this.taxAmount + this.shippingCost;
          this.finalAmount = Number(this.finalAmount.toFixed(2));
          this.invoice_id = result.data.invoice_id;
          this.incl = result.data.incl;
          if (this.incl)
            this.taxAmount = 0;
          callback();
        } else {
          this.toastr.error('Unable to get tax');
        }
      })
    }
    else {
      this.taxPercentage = 0;
      this.taxAmount = 0;
      this.finalAmount = this.productsTotal + this.taxAmount + this.shippingCost;
      this.finalAmount = Number(this.finalAmount.toFixed(2));
      this.invoice_id = '';
      this.incl = '';
      this.cd.detectChanges();
      callback();
    }
  }




  isShowT_C: boolean = false;
  showHideTermsAndConditions() {
    this.isShowT_C = !this.isShowT_C;
  }

  isAgrees = false;
  paymentSuccess: boolean = false;
  shippingCodes: any;
  async makePayment(from?) {
    this.checkoutTimer = 0;
    try { fbq('track', 'StripePay'); } catch (e) { }
    let amount, name;
    amount = this.productsTotal;
    name = this.userInfo.user_display_name || this.userInfo.display_name

    if (this.transactionInfo["card"] || from == 'card' || this.transactionInfo["mode"]) {
      this.toggleLoader('');
      this.paymentDetails();
      // let checkoutUrl = API.INITIATE_CHECKOUT + '?NOLOADER';
      // let params = { "stream_id": this.streamId }
      // this.appPaymentService.postRequest(checkoutUrl, params).subscribe(result => {
      //   if (result['status'] == 0 && result.message == 'Success') {
      //     this.paymentDetails();
      //   } else {
      //     if (result.message.includes('discount')) {
      //       this.toastr.info(result.message)
      //       this.openDialog('', 'checkout');
      //     } else {
      //       this.toastr.info(result.message);
      //     }
      //   }
      // });



    } else if (!this.cardError) {
      this.toggleLoader('none');
      this.cardError = "Please fill all the fields";
    }
  }

  paymentResp: any;
  cartUrl: any;
  isPayment: boolean = false;
  paymentDetails() {
    this.isPayment = true;
    this.cartUrl = '';
    let amount, name;
    amount = this.productsTotal;
    name = this.userInfo.user_display_name || this.userInfo.display_name;
    let id = this.route.snapshot.params.eventId ? this.route.snapshot.params.eventId.split('-') : "";
    let eventId = id && id[0] ? id[0] : this.streamInfo.parent_streams_id;
    let paymentParams = {
      "event_id": Number(eventId),
      "stream_id": this.streamId,
      "cart_id": this.cart_id,
      "currency": this.transactionInfo.currency ? this.transactionInfo.currency : this.productCurrency.toLowerCase() || 'gbp',
      "total_price": this.selectedTransaction == "crypto" ? this.crypto_amount : this.finalAmount,
      "creator_currency": this.streamInfo.currency_type
    }
    paymentParams['billing_address'] = {
      line1: this.getBillingValue.address1 ? this.getBillingValue.address1 : this.selectedBillingAddress && this.selectedBillingAddress.line1 ? this.selectedBillingAddress.line1 : "",
      line2: this.getBillingValue.address2 ? this.getBillingValue.address2 : this.selectedBillingAddress && this.selectedBillingAddress.line2 ? this.selectedBillingAddress.line2 : "",
      city: this.getBillingValue.city ? this.getBillingValue.city : this.selectedBillingAddress && this.selectedBillingAddress.city ? this.selectedBillingAddress.city : "",
      state: this.getBillingValue.state ? this.getBillingValue.state : this.selectedBillingAddress && this.selectedBillingAddress.state ? this.selectedBillingAddress.state : "",
      state_code: this.codes.state ? this.codes.state : this.selectedBillingAddress && this.selectedBillingAddress.state_code ? this.selectedBillingAddress.state_code : "",
      zip: this.getBillingValue.zip ? this.getBillingValue.zip : this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : "",
      country: this.getBillingValue.country.name ? this.getBillingValue.country.name : this.selectedBillingAddress && this.selectedBillingAddress.country ? this.selectedBillingAddress.country : "",
      country_code: this.codes.country ? this.codes.country : this.selectedBillingAddress && this.selectedBillingAddress.country_code ? this.selectedBillingAddress.country_code : "",
    };
    let phnNum = this.getShippingValue.phone_number;
    let num = (phnNum && phnNum.number) ? phnNum.number.replace(/\W+/g, '') : '';
    let dial_code = phnNum && phnNum.dialCode;
    let selShipNum = this.selectedShippingAddress && this.selectedShippingAddress.mobile ? this.selectedShippingAddress.dial_code + this.selectedShippingAddress.mobile : "";
    if (this.showShippingForm) {
      paymentParams['shipping_address'] = {
        line1: this.getShippingValue.address1 ? this.getShippingValue.address1 : this.selectedShippingAddress && this.selectedShippingAddress.line1 ? this.selectedShippingAddress.line1 : '',
        line2: this.getShippingValue.address2 ? this.getShippingValue.address2 : this.selectedShippingAddress && this.selectedShippingAddress.line2 ? this.selectedShippingAddress.line2 : '',
        city: this.getShippingValue.city ? this.getShippingValue.city : this.selectedShippingAddress && this.selectedShippingAddress.city ? this.selectedShippingAddress.city : "",
        state: this.getShippingValue.state ? this.getShippingValue.state : this.selectedShippingAddress && this.selectedShippingAddress.state ? this.selectedShippingAddress.state : "",
        state_code: this.codes.state ? this.codes.state : this.selectedShippingAddress && this.selectedShippingAddress.state_code ? this.selectedShippingAddress.state_code : "",
        zip: this.getShippingValue.zip ? this.getShippingValue.zip : this.selectedShippingAddress && this.selectedShippingAddress.zip ? this.selectedShippingAddress.zip : "",
        country: this.getShippingValue.country.name ? this.getShippingValue.country.name : this.selectedShippingAddress && this.selectedShippingAddress.country ? this.selectedShippingAddress.country : "",
        country_code: this.codes.country ? this.codes.country : this.selectedShippingAddress && this.selectedShippingAddress.country ? this.selectedShippingAddress.country : "",
        phone_number: dial_code && num ? dial_code + num : selShipNum
      };
    }
    paymentParams['processing_fee'] = this.processingFee;
    paymentParams['tax_amount'] = this.taxAmount;
    paymentParams['tax_percentage'] = this.taxPercentage;
    paymentParams['shipping_cost'] = this.shippingCost ? this.shippingCost : undefined;
    paymentParams['discount_amount'] = this.discountAmount ? this.discountAmount : undefined;
    if (this.paymentResp) {
      paymentParams['transaction_id'] = this.paymentResp['transaction_id'];
      paymentParams['client_secret'] = this.paymentResp['client_secret'];
      paymentParams['order_id'] = this.paymentResp['order_id'];
    }
    paymentParams['amount'] = amount;
    if (this.digitalProducts.length > 0) {
      paymentParams['email'] = this.email;
    }
    paymentParams['invoice_id'] = this.invoice_id ? this.invoice_id : undefined;

    let code;
    if (this.selectedBillingAddress && this.selectedBillingAddress.line1) {
      code = this.selectedBillingAddress.country_code ? this.selectedBillingAddress.country_code : this.selectedBillingAddress.country
      let country;
      if (this.selectedBillingAddress.country_code) {
        country = COUNTRIES_LIST.filter(country => country.alpha3code == code);
      } else if (this.selectedBillingAddress.country) {
        country = COUNTRIES_LIST.filter(country => country.alpha2code == code);
      }
      code = country[0].alpha2code;
    }
    let billingAddress;
    billingAddress = {
      'line1': paymentParams['billing_address'].line1,
      'line2': paymentParams['billing_address'].line2,
      'city': paymentParams['billing_address'].city,
      'state': paymentParams['billing_address'].state,
      'country': this.getBillingValue.country.alpha2code ? this.getBillingValue.country.alpha2code : code ? code : "",
      'postal_code': paymentParams['billing_address'].zip
    }
    let cardInfo = {
      'card': this.card,
      'billing_details': {
        'name': name || this.userInfo.user_first_name + ' ' + this.userInfo.user_last_name,
        'address': billingAddress
      }
    }
    if (this.userInfo && !this.userInfo.is_guest) {
      if (this.getBillingValue.address1 && this.showBillingForm) {
        paymentParams['new_billing'] = {
          "type": 'billing',
          "name": name || this.userInfo.user_first_name + ' ' + this.userInfo.user_last_name,
          "line1": this.getBillingValue.address1,
          "line2": this.getBillingValue.address2,
          "city": this.getBillingValue.city,
          "state": this.getBillingValue.state,
          "state_code": this.codes.state,
          "country": this.getBillingValue.country.name,
          "country_code": this.codes.country,
          "zip": this.getBillingValue.zip,
          "remove_default": false,
          "default": false,
        }
      }
    if (this.getShippingValue.address1 && this.showShippingForm) {
      let phnNum = this.getShippingValue.phone_number;
      let num = (phnNum && phnNum.number) ? phnNum.number.replace(/\W+/g, '') : '';
      let dial_code = phnNum && phnNum.dialCode;
      paymentParams['new_shipping'] = {
        "type": 'shipping',
        "name": name || this.userInfo.user_first_name + ' ' + this.userInfo.user_last_name,
        "mobile": num,
        "dial_code": dial_code,
        "line1": this.getShippingValue.address1,
        "line2": this.getShippingValue.address2,
        "city": this.getShippingValue.city,
        "state": this.getShippingValue.state,
        "state_code": this.shippingCodes.state,
        "country": this.getShippingValue.country.name,
        "country_code": this.shippingCodes.country,
        "zip": this.getShippingValue.zip,
        "remove_default": false,
        "default": false,
      }
    }
    }
    paymentParams["transaction_amount"] = this.transactionInfo['transaction_amount'];
    paymentParams["payment_gateway"] = this.transactionInfo['mode'] == 'wallet' ? "wallet" : this.transactionInfo['mode'] == 'crypto' ? 'crypto' : undefined;
    paymentParams["stream_video_title"] = this.streamInfo.stream_video_title;
    paymentParams["crypto_wallet_id"] = this.transactionInfo.crypto_wallet_id ? this.transactionInfo.crypto_wallet_id : undefined;
    paymentParams["exchange_rate"] = this.transactionInfo.exchange_rate ? this.transactionInfo.exchange_rate : 1;
    
 if((paymentParams['referral_code']===undefined || paymentParams["referral_code"]===null) && localStorage.getItem('affiliateReferralCode')){
      const referralCode = localStorage.getItem('affiliateReferralCode');
      paymentParams['referral_code'] = referralCode && referralCode != "undefined" ? JSON.parse(referralCode) : '';
    }
    paymentParams["organization_id"] = this.streamInfo?.organization_id;
    paymentParams["network_group_id"] = this.streamInfo?.network_group_id || this.commonSubscribeService?.activeGroupId || null;

    
    paymentParams["organization_id"] = this.streamInfo?.organization_id;
    paymentParams["network_group_id"] = this.streamInfo?.network_group_id || this.commonSubscribeService?.activeGroupId || null;
    let paymentUrl = API.INITIATE_PAYMENT + '?NOLOADER';
    if(this.transactionInfo['mode'] == 'wallet' || this.transactionInfo['mode'] == "crypto"){
      this.appPaymentService.postRequest(paymentUrl, paymentParams).subscribe(result => {
        if (result['status'] == 0 && result['message'] == "Success") {
          if (result['status'] == 0) {
            this.paymentResp = result;
            paymentParams['transaction_id'] = result['transaction_id'];
            this.transactionInfo['id'] = result['id'] ? result['id'] : result['client_secret'];
            this.completeTransaction(paymentParams,this.transactionInfo["paymentIntent"]);
            return;
            // this.loader.start();
            
          } else {
            this.showOverlay = false;
            this.toggleLoader('none');
            this.commonSubscribeService.sendPaymentStatus(false);
            try { fbq('track', 'StripeInitFailed'); } catch (e) { }
            this.toastr.error(result.message)
            this.ngxLoader.stop();
          }
        } else {
          this.toastr.error(result["message"]);
          let errors = result["errors"];
          if (errors && Object.keys(errors).length > 0) {
            this.cartProducts.forEach(e => {
              for (const [key, value] of Object.entries(errors)) {
                if (key == e.id) {
                  e.invNotAvailable = true;
                  e.inventory = value["inventory"];
                }
              }
            })
            const sorted = this.cartProducts.sort((a, b) => a.invNotAvailable ? -1 : 1);
            this.cartProducts = sorted;
            this.showAddressForms = false;
            this.showPaymentForm = false;
            this.activeBlock = "Merchandise";
            this.continueSession = true;
            this.cartUrl = environment.CONSUMER_PORTAL + 'event/stream/' + this.ticket_key + '/errors/' + JSON.stringify(errors) + '?stage=' + this.streamId;
          }
          this.showOverlay = false;
          this.toggleLoader('none');
        }
      });
      return;
    }
    this.appPaymentService.postRequest(paymentUrl, paymentParams).subscribe(result => {
      if (result['status'] == 0 && result['message'] == "Success") {
        if (result['status'] == 0) {
          this.paymentResp = result;
          paymentParams['transaction_id'] = result['transaction_id'];
          // this.loader.start();
          this.transactionInfo.stripe.confirmCardPayment(result['client_secret'], {
            payment_method: Object.keys(this.selectedCard).length > 0 ? this.selectedCard.id : cardInfo,
            setup_future_usage: Object.keys(this.selectedCard).length > 0 ? undefined : 'off_session'
            // payment_method: {
            //   card: this.card,
            //   billing_details: {
            //     name: name || this.userInfo.user_first_name + ' ' + this.userInfo.user_last_name
            //   }
            // }
          }).then((result) => {
            console.log(result);
            if (result.error) {
              this.toggleLoader('none');
              this.showOverlay = false;
              this.isPayment = false;
              // Show error to your customer (e.g., insufficient funds)
              this.toastr.error(result.error.message);
            } else {
              // The payment has been processed!
              if (result.paymentIntent.status === 'succeeded') {
                try { fbq('track', 'StripePaymentSuccess'); } catch (e) { }
                this.transactionInfo['id'] = result.paymentIntent.id;
                this.completeTransaction(paymentParams,result.paymentIntent);
              }
            }
            this.toggleLoader('none');
          });
        } else {
          this.showOverlay = false;
          this.toggleLoader('none');
          this.commonSubscribeService.sendPaymentStatus(false);
          try { fbq('track', 'StripeInitFailed'); } catch (e) { }
          this.toastr.error(result.message)
          this.ngxLoader.stop();
        }
      } else {
        this.toastr.error(result["message"]);
        let errors = result["errors"];
        if (errors && Object.keys(errors).length > 0) {
          this.cartProducts.forEach(e => {
            for (const [key, value] of Object.entries(errors)) {
              if (key == e.id) {
                e.invNotAvailable = true;
                e.inventory = value["inventory"];
              }
            }
          })
          const sorted = this.cartProducts.sort((a, b) => a.invNotAvailable ? -1 : 1);
          this.cartProducts = sorted;
          this.showAddressForms = false;
          this.showPaymentForm = false;
          this.activeBlock = "Merchandise";
          this.continueSession = true;
          this.cartUrl = environment.CONSUMER_PORTAL + 'event/stream/' + this.ticket_key + '/errors/' + JSON.stringify(errors) + '?stage=' + this.streamId;
        }
        this.showOverlay = false;
        this.toggleLoader('none');
      }
    });
  }

  completeTransaction(paymentParams, result) {
    let paramValues = {
      id: this.transactionInfo['id'] ? this.transactionInfo['id'] : this.paymentResp['client_secret'],
      currency: this.transactionInfo.currency ? this.transactionInfo.currency : this.productCurrency,
      creator_currency: this.streamInfo.currency_type,
      card_id: this.transactionInfo['save_card'] ? result.payment_method : undefined,
      new_shipping: paymentParams['new_shipping'] ? paymentParams['new_shipping'] : undefined,
      new_billing: paymentParams['new_billing'] ? paymentParams['new_billing'] : undefined
    }
    paramValues["payment_gateway"] = this.transactionInfo['mode'] == 'wallet' ? "wallet" : this.transactionInfo['mode'] == 'crypto' ? 'crypto' : undefined;
    paramValues["transaction_amount"] = this.transactionInfo['transaction_amount'];
    paramValues["crypto_wallet_id"] = this.transactionInfo.crypto_wallet_id ? this.transactionInfo.crypto_wallet_id : undefined;
    paramValues["network_group_id"] = this.streamInfo?.network_group_id || this.commonSubscribeService?.activeGroupId || null;
    paramValues["organization_id"] = this.streamInfo?.organization_id || undefined;
    // paramValues["order_id"] = this.paymentResp.order_id;
    // paramValues["cart_id"] = this.cart_id;
    let url = API.COMPLETE_PAYMENT + '?NOLOADER';
    this.appPaymentService.postRequest(url, paramValues).subscribe(result => {
      if (result['status'] == 0 && result['message'] == "Success") {
        this.showOverlay = false;
        this.toastr.success("Payment completed successfully");
        this.paymentSuccess = true;
        this.showPaymentForm = false;
        this.isPayment = false;
        this.commonSubscribeService.updateAvailBalSubject.next(true);
        this.getShoppingCartList();
      } else {
        try { fbq('track', 'StripePaymentFailed'); } catch (e) { }
        this.showOverlay = false;
        this.toastr.error(result['message']);
      }

    });
  }

  showOverlay: boolean = false;
  timer = 120;
  toggleLoader(state) {
    if (state != 'none') {
      this.showOverlay = true;
      var counter = 120;
      var interval = setInterval(() => {
        counter--;
        if (counter <= 0) {
          clearInterval(interval);
          return;
        } else {
          this.timer = counter;
        }
      }, 1000);
    }
    // var overlay = document.getElementsByClassName('ngx-overlay');
    // overlay[0]['style'].display = state;
    if (state == 'none') {
      this.ngxLoader.stop();
    }
  }

  close() {
    this.checkoutTimer = 0;
    this.commonSubscribeService.checkoutTimer.next(this.checkoutTimer);
    this.getPaymentData.emit('order');
  }

  ngOnDestroy() {
    this.card = '';
    elements = '';
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
    if (this.userInfoSubscription) {
      this.userInfoSubscription.unsubscribe();
    }
    if (this.showActiveStreamBlockSubject) {
      this.showActiveStreamBlockSubject.unsubscribe();
    }
    if (this.currencyInfoSubscription) {
      this.currencyInfoSubscription.unsubscribe();
    }
    if (this.ratesInfoSubscr) {
      this.ratesInfoSubscr.unsubscribe();
    }
    if (this.activeProductsSubscr) {
      this.activeProductsSubscr.unsubscribe();
    }
    if (this.slugInfoSubscr) {
      this.slugInfoSubscr.unsubscribe();
    }
    if (this.selectedCardInfoSubscr) {
      this.selectedCardInfoSubscr.unsubscribe();
    }
    if (this.addressListInfoSubscr) {
      this.addressListInfoSubscr.unsubscribe();
    }
    if (this.savedCardsListSubscr) {
      this.savedCardsListSubscr.unsubscribe();
    }
    if(this.transactionInfoSubscr){
      this.transactionInfoSubscr.unsubscribe();
    }
    if(this.formStatusSubject){
      this.formStatusSubject.unsubscribe();
    }
    if(this.totalAmount){
      this.totalAmount.unsubscribe();
    }
    this.performerInfoSubscription?.unsubscribe();
  }

}
